<template>
    <v-container id="search-page">
        <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
        <loading :active.sync="isLoading" :is-full-page="true"></loading>
        <v-row class="my-10">
            <v-col>
                <span class="text-tcdc-green header bold">{{$route.hash}}</span>
            </v-col>
        </v-row>

        <v-tabs color="#34A93E" v-model="mode" class="mb-7">
            <v-tab>{{$t('searchPage.articles')}}</v-tab>
        </v-tabs>

      <div v-if="mode === 0 && searchArticleResult">
        <v-list v-if="searchArticleResult.data && searchArticleResult.data.length > 0">
          <v-list-item v-for="(item, i) in searchArticleResult.data" :key="i" class="mb-3">
            <v-layout column>
              <v-layout align-center>
                <v-flex shrink mr-3 cursor-pointer @click="seeDetail('article', item.article_id)">
                  <v-img
                      v-if="item.cover_img_path"
                      eager
                      :src="item.cover_img_path"
                      width="60px"
                      height="60px"
                      style="border-radius: 4px;"
                  />
                  <v-img
                      v-else
                      eager
                      :src="require('../../assets/uploadImage.jpg')"
                      width="60px"
                      height="60px"
                      style="border-radius: 4px;"
                  />
                </v-flex>
                <v-flex>
                  <div class="text-tcdc-green bold cursor-pointer" @click="seeDetail(item.article_id)">
                    {{ item[`subject_${lang}`] ? item[`subject_${lang}`] : item.subject_th }}
                  </div>
                </v-flex>
              </v-layout>
              <v-divider class="mt-3" />
            </v-layout>
          </v-list-item>
        </v-list>
        <div v-else class="grey--text text-center">
          {{$t('searchPage.no-record')}}
        </div>

        <v-layout justify-center v-if="searchArticleResult.data && searchArticleResult.data.length > 0">
          <GreenButton
              v-if="searchArticleResult.current_page !== 1"
              :label="$t('searchPage.prevPage')"
              @onPress="onPageChange(searchArticleResult.current_page - 1)"
          ></GreenButton>
          <div class="text-tcdc-grey1 grey--text mx-7">
            {{ searchArticleResult.from }} - {{ searchArticleResult.to }} {{ $t('article.from') }} {{ searchArticleResult.total }}
          </div>
          <GreenButton
              v-if="searchArticleResult.current_page !== searchArticleResult.last_page"
              :label="$t('searchPage.nextPage')"
              @onPress="onPageChange(searchArticleResult.current_page + 1)"
          ></GreenButton>
        </v-layout>
<!--        <v-pagination-->
<!--            v-if="searchArticleResult.data.length > 0"-->
<!--            v-model="searchArticleResult.current_page"-->
<!--            :total-visible="7"-->
<!--            :length="searchArticleResult.last_page"-->
<!--            prev-icon="mdi-menu-left"-->
<!--            next-icon="mdi-menu-right"-->
<!--            color="#2e8037"-->
<!--            @input="onPageChange"-->
<!--        ></v-pagination>-->
      </div>

    </v-container>
</template>

<script>
    import { mapState } from 'vuex'
    import Loading from 'vue-loading-overlay'
    import { Utils } from "@/util/Utils"
    import GreenButton from "@/components/buttons/GreenButton"

    export default {
        components: {
            Loading,
          GreenButton
        },
        async created() {
            this.items[0].text = this.branchName;
            let path;
            for (const b of this.allBranches) {
                if (this.branchId === b.branch_id) {
                    if (this.branchId === 0) {
                        path = `/home`;
                        break;
                    }
                    path = `/home/${b.tag_name}`;
                    break;
                }
            }
            this.items[0].to = path;
            this.onSearch()
        },
        computed: {
            ...mapState({
                branchName: state => state.Branch.branch_name,
                allBranches: state => state.Branch.branches,
                branchId: state => state.Branch.branch_id,
                tag_name: state => state.Branch.tag_name,
                lang: state => state.Branch.lang,
                searchArticleResult: state => {
                    if (state.Search.result.article) {
                        return state.Search.result.article;
                    }
                    return []
                }
            }),
            branchChanged: function () {
                return this.branchName;
            },
            hashChanged: function () {
                return this.$route.hash;
            }
        },
        watch: {
            branchChanged: function() {
                this.items[0].text = this.branchChanged;
                let path;
                for (const b of this.allBranches) {
                    if (this.branchId === b.branch_id) {
                        if (this.branchId === 0) {
                            path = `/home`;
                            break;
                        }
                        path = `/home/${b.tag_name}`;
                        break;
                    }
                }
                this.items[0].to = path;
            },
            hashChanged: function () {
              this.onSearch()
            }
        },
        methods: {
            async onSearch() {
                if (this.$route.hash) {
                  let keyword = this.$route.hash.split('#')[1]
                    await this.$store.dispatch('Search/onClearResult');
                    this.isLoading = true;
                    let article = {
                        keyword: keyword,
                        tag: this.tag_name,
                        mode: 2,
                        page: 1
                    };
                    await Promise.all([
                      this.$store.dispatch('Search/onSearch', article)
                    ]).catch(() => {
                      this.isLoading = false;
                    })
                    this.isLoading = false;
                }
            },
            async onPageChange(page) {
              let keyword = this.$route.hash.split('#')[1]
              this.isLoading = true;
              let x = {
                    keyword: keyword,
                    tag: this.tag_name,
                    mode: 2,
                    page: page
                };
              await this.$store.dispatch('Search/onSearch', x);
              this.isLoading = false;
            },
            openLink(url) {
                if (url) {
                    window.open(url);
                }
            },
            seeDetail(id) {
                if (id) {
                  const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
                  // this.$router.push({ name: "ArticleDetail", params: { id: id, branch: branch } });
                  this.$router.push(`/${this.lang}`+`${branch}/service/resource-center/article/${id}`);
                }
            }
        },
        async beforeDestroy() {
            await this.$store.dispatch('Search/onClearResult');
        },
        data: () => ({
            items: [
                {
                    text: 'TCDC BANGKOK',
                    to: "/home"
                },
                {
                    text: "SEARCH",
                }
            ],
            mode: 0,
            isLoading: false
        })
    };
</script>

<style lang="scss">
.borderbot-searchmain {
    border-bottom: solid 2px #34A93E;
}
.theme--light.v-input input#search-main,
input#search-main::placeholder {
    font-size: 1.5rem;
    line-height: 36px;
    font-family: "Poppins", "Kanit", sans-serif;
}
.v-text-field input#search-main,
.v-text-field input#search-box {
    height: 60px !important;
    max-height: unset !important;
    font-family: "Poppins", "Kanit", sans-serif;
}

</style>
